export default __webpack_public_path__ + "static/media/4.a7076b7b.svg";